import { render, staticRenderFns } from "./OfertaInfoPrecos.vue?vue&type=template&id=b22eaefa&"
import script from "./OfertaInfoPrecos.vue?vue&type=script&lang=js&"
export * from "./OfertaInfoPrecos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports